import { AnimatePresence } from "framer-motion";
import { ANNOUNCEMENT_TYPES } from "../../constants";
import { useAnnouncementsStore } from "../../store";
import { AnnouncementBanner } from "../AnnouncementBanner";

export const GlobalAnnouncement = () => {
    const {
        previewAnnouncement,
        liveAnnouncement,
        setPreviewAnnouncement,
    } = useAnnouncementsStore();

    const announcement = previewAnnouncement ?? liveAnnouncement;
    const isPreview = !!previewAnnouncement;
    const isBanner = announcement?.type === ANNOUNCEMENT_TYPES.BANNER;

    return (
        <AnimatePresence>
            {isBanner && (
                <AnnouncementBanner
                    title={announcement.title}
                    description={announcement.description}
                    severity={announcement.severity}
                    onClose={() => {
                        if (isPreview) {
                            setPreviewAnnouncement(null);
                        } else {
                            announcement.onHide?.();
                        }
                    }}
                />
            )}
        </AnimatePresence>
    );
};
